
import { Uuid } from "../../../../domain/model/uuid/uuid.type";
import { DataStoreId } from "../../data-store-id.type";

export class StorePen implements DataStoreId {
  readonly id: string;
  readonly sectionId: string;
  readonly name: string;
  readonly number: number;

  constructor(id: Uuid, sectionId: Uuid, name: string, number: number) {
    this.id = id.asString();
    this.sectionId = sectionId.asString();
    this.name = name;
    this.number = number;
  }
}
